import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IAttachmentDescriptionProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    AttachmentPartContentProps
} from "../../type";
import {
    Clock as ClockIcon
} from "lucide-react-native";
import {
    formatPercent
} from "../../../../helpers/locale";
import {
    withAttachmentContext
} from "../../context";
import Icon from "../../../icon";
import Text from "../../../text";

const AttachmentDescriptionContent: FC<AttachmentPartContentProps<IAttachmentDescriptionProps>> = ({
    customTheme,
    children,
    context,
    style,
    ...props
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme ?? context.customTheme);

    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    const getText = () => {
        if(children !== undefined) {
            return children;
        }

        if(context.uploadState === "error") {
            return context.errorText ?? localize("upload-failed");
        }

        if(context.uploadState === "idle") {
            return localize("attachment-queued");
        }

        if(context.uploadState === "processing") {
            return context.description ?? localize("attachment-scanning");
        }

        if(context.uploadState === "uploading" && context.progress !== undefined) {
            return context.description ?? formatPercent({
                value: context.progress / 100,
                locale: activeLocale
            });
        }

        return context.description;
    };

    const text = getText();

    if(text === undefined || text === null || text === "") {
        return null;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {
            context.uploadState === "idle" && children === undefined ?
                <Icon
                    customTheme={customTheme ?? context.customTheme}
                    size={context.currentSize.descriptionIconSize}
                    icon={ClockIcon}
                    color="mid"
                />
            :
                null
        }
        {
            typeof text === "string" ?
                <Text
                    numberOfLines={context.uploadState === "error" ? undefined : 1}
                    customColor={context.currentColors.descriptionColor}
                    customTheme={customTheme ?? context.customTheme}
                    variant={context.currentSize.descriptionVariant}
                    style={stylesheet.text}
                >
                    {text}
                </Text>
            :
                text
        }
    </View>;
};
export default withAttachmentContext("Description", AttachmentDescriptionContent);
